import { RequireOnly } from '@pelicargo/types';
import { Quote, Request } from '@prisma/client';
import { isFinite } from 'lodash';

export const hasPivotWeight = (
  quote: RequireOnly<Quote, 'chargeable_weight'>,
  request: RequireOnly<Request, 'chargeable_weight'>,
) =>
  isFinite(quote.chargeable_weight) &&
  isFinite(request.chargeable_weight) &&
  Math.abs(quote.chargeable_weight - request.chargeable_weight) >= 5;
